<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="33rem"
    style="top: 100px"
    stateless
  >
    <v-form class="d-flex flex-column" style="height: calc(100% - 100px)">
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="handleClickBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-list-item class="px-0" two-line>
          <v-list-item-content>
            <v-list-item-title>
              {{ employee.firstname_th }} {{ employee.lastname_th }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ employee.employee_code }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <p>
          {{ biometric.title_th || 'ลายนิ้วมือ' }}
        </p>
        <div
          v-for="item in employeeBiometric.filter(
            (e) => e.biometric_code === biometric.biometric_code
          )"
          :key="item.biometric_code"
        >
          <v-card
            v-for="bio in item.biometric_property"
            :key="bio.biometric_property_code"
            style="cursor: pointer"
            class="mt-3 pa-2 d-flex justify-space-between"
            outlined
            @click="handleClickEditFinger(bio)"
          >
            <div class="d-flex align-center">
              <v-list-item-avatar size="56" class="ma-0 pa-0">
                <v-icon x-large>mdi-fingerprint</v-icon>
              </v-list-item-avatar>
              <div class="ml-2">
                <div>{{ bio.title_th }}</div>
                <div>
                  <span
                    v-if="bio.employee_biometric"
                    style="font-size: 12px"
                    class="gray--text"
                  >
                    อัพเดตเมื่อ
                    {{ bio.employee_biometric.last_updated | formatDate }}
                  </span>
                </div>
              </div>
            </div>
            <v-icon>mdi-chevron-right</v-icon>
          </v-card>
        </div>
        <div
          class="mt-5"
          v-if="
            (employeeBiometric.find(
              (e) => e.biometric_code === biometric.biometric_code
            )?.biometric_property?.length || 0) <
            (biometric.biometric_property &&
              biometric.biometric_property.length)
          "
        >
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::biometric:update_delete')
            "
            @click="handleClickAddFinger"
            class="primary"
            depressed
          >
            <v-icon left>mdi-plus</v-icon>
            เพิ่ม
          </v-btn>
        </div>
      </div>
    </v-form>
  </v-navigation-drawer>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    formShow: {
      type: Boolean,
      required: true,
    },
    employee: {
      type: Object,
      required: true,
    },
    biometric: {
      type: Object,
      required: true,
    },
  },

  filters: {
    formatDate: function (value) {
      return moment(value).format('DD/MM/YYYY HH:mm:ss')
    },
  },

  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    employeeBiometric() {
      return this.$store.state.employee.employeeBiometric
    },
  },

  methods: {
    handleClickBack() {
      this.$emit('onClickBack')
    },
    handleClickAddFinger() {
      this.$emit('onClickAddFinger')
    },
    handleClickEditFinger(biometric) {
      this.$emit('onClickEditFinger', biometric)
    },
  },
}
</script>
